import { API } from "../../constants";
import { ApiResponse } from "../../types";
import { apiSlice } from "../api-slice";
import { NewPrintStyle, PrintStyle } from "./types";

const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getAllPrintStyles: build.query<PrintStyle[], void>({
      query: () => `${API}/print-styles`,
      providesTags: (result) =>
        result ? result.map(({ id }) => ({ type: "PrintStyle" as const, id })) : [{ type: "PrintStyle" as const }],
    }),
    createPrintStyle: build.mutation<ApiResponse<PrintStyle>, PrintStyle>({
      query: (printStyles) => ({ method: "POST", url: `${API}/print-styles`, body: printStyles }),
      invalidatesTags: ["PrintStyle"],
    }),
    deletePrintStyle: build.mutation<ApiResponse<PrintStyle>, boolean>({
      query: (id) => ({ method: "DELETE", url: `${API}/print-styles/${id}` }),
      invalidatesTags: ["PrintStyle"],
    }),
    editPrintStyle: build.mutation<ApiResponse<PrintStyle>, PrintStyle | NewPrintStyle>({
      query: (printStyle) => ({
        method: "POST",
        url: `${API}/print-styles`,
        body: [printStyle],
      }),
      invalidatesTags: ["PrintStyle"],
    }),
  }),
});

export const {
  useGetAllPrintStylesQuery,
  useLazyGetAllPrintStylesQuery,
  useCreatePrintStyleMutation,
  useDeletePrintStyleMutation,
  useEditPrintStyleMutation,
} = extendedApiSlice;
